export default "__VITE_ASSET__DtegdG2O__"